module.exports = __webpack_public_path__ + "aa1cd91354e05bf0ec96a18dba6a4e1b.jpg";